import { IPagination } from 'app/types/common';

export interface IOrgTeamsState {
  readonly orgTeamsById?: any;
  readonly orgTeamIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrgTeamLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrgTeam?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrgTeamIds?: string[];
  readonly currentOrgTeamId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrgTeamsSelector extends IOrgTeamsState {
  readonly currentOrgTeam?: any;
  readonly currentFormOrgTeam?: any;
  readonly getOrgTeamsFilteredByTagInSelectFormat?: any;
  readonly OrgTeamsByIdInSelectFormat?: any;
}

export enum OrgTeamsActionTypes {
  GET_ALL_ORG_TEAMS_REQUESTED = 'redux-app/org-teams/GET_ALL_ORG_TEAMS_REQUESTED',
  GET_ALL_ORG_TEAMS_PENDING = 'redux-app/org-teams/GET_ALL_ORG_TEAMS_PENDING',
  GET_ALL_ORG_TEAMS_SUCCESS = 'redux-app/org-teams/GET_ALL_ORG_TEAMS_SUCCESS',
  GET_ALL_ORG_TEAMS_FAIL = 'redux-app/org-teams/GET_ALL_ORG_TEAMS_FAIL',
  GET_ORG_TEAM_REQUESTED = 'redux-app/org-teams/GET_ORG_TEAM_REQUESTED',
  GET_ORG_TEAM_PENDING = 'redux-app/org-teams/GET_ORG_TEAM_PENDING',
  GET_ORG_TEAM_SUCCESS = 'redux-app/org-teams/GET_ORG_TEAM_SUCCESS',
  GET_ORG_TEAM_FAIL = 'redux-app/org-teams/GET_ORG_TEAM_FAIL',
  SELECT_ORG_TEAM_REQUESTED = 'redux-app/org-teams/SELECT_ORG_TEAM_REQUESTED',
}

export interface IOrgTeam {
  id: string;
  organisationName: string;
  competitionId: string;
  competitionName: string;
  createdOn: string;
  updatedOn: string;
  name: string;
  uniqueKey: string;
  generatedUniqueKey: string;
  teamType: string;
  people: { name: string; id: string }[];
  sectionName: string;
  seasonName: string;
  numberOfTeamContacts: number;
  numberOfMatches: number;
  numberOfForfeits: number;
  unpaidNumberOfPayments: number;
  unpaidTotalPaymentsAmountInDollars: number;
  unpaidTotalPaymentsAmountInCents: number;
  paidNumberOfPayments: number;
  paidTotalPaymentsAmountInDollars: number;
  paidTotalPaymentsAmountInCents: number;
  overdueNumberOfPayments: number;
  overdueTotalPaymentsAmountInDollars: number;
  overdueTotalPaymentsAmountInCents: number;
  financialStatus: string;
  financialStatusHumanised: string;
  financialStatusColour: string;
}

export default null;
